import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SoundcloudPlayer from './SoundcloudPlayer';
import YoutubePlayer from './YoutubePlayer';
import Header from './Header';
import './Playground.css';

const phrases = [
  { text: "music", initialX: -100, initialY: -50, initialRotate: -15 },
  { text: "makes the people", initialX: 100, initialY: 50, initialRotate: 15 },
  { text: "come together", initialX: 0, initialY: 100, initialRotate: 0 }
];

export const Playground = () => {
  const [showPhrases, setShowPhrases] = useState(true);
  const [showMusic, setShowMusic] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPhrases(false);
      setTimeout(() => {
        setShowMusic(true);
      }, 1000);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const [activePlayer, setActivePlayer] = useState<'soundcloud' | 'youtube' | null>(null);
  const [isPlayingSoundcloud, setIsPlayingSoundcloud] = useState(false);
  const [isPlayingYoutube, setIsPlayingYoutube] = useState(false);

  const handleSoundcloudPlay = () => {
    setActivePlayer('soundcloud');
    setIsPlayingSoundcloud(true);
    setIsPlayingYoutube(false); // Stop YouTube if playing
  };

  const handleYoutubePlay = () => {
    setActivePlayer('youtube');
    setIsPlayingYoutube(true);
    setIsPlayingSoundcloud(false); // Stop SoundCloud if playing
  };

  const handleSoundcloudPause = () => {
    setIsPlayingSoundcloud(false);
  };

  const handleYoutubePause = () => {
    setIsPlayingYoutube(false);
  };

  return (
    <div className="page-content">
      <Header />

      <AnimatePresence>
        {showPhrases && (
          <>
            <div className="phrase-container">
              {phrases.map((phrase, index) => (
                <motion.div
                  key={phrase.text}
                  className="phrase"
                  initial={{
                    x: phrase.initialX,
                    y: phrase.initialY,
                    rotate: phrase.initialRotate,
                    opacity: 0,
                    filter: "blur(10px)"
                  }}
                  animate={{
                    x: 0,
                    y: 0,
                    rotate: 0,
                    opacity: 1,
                    filter: "blur(0px)"
                  }}
                  exit={{
                    opacity: 0,
                    scale: 0.8,
                    transition: { duration: 0.5 }
                  }}
                  transition={{
                    duration: 1.5,
                    delay: index * 0.5,
                    ease: "easeOut"
                  }}
                >
                  {phrase.text}
                </motion.div>
              ))}
            </div>
          </>
        )}
      </AnimatePresence>
      {showMusic && (
        <motion.div
          className='audio-container'
          initial={{
            opacity: 0,
            scale: 0.5,
            filter: "blur(10px)"
          }}
          animate={{
            opacity: 1,
            scale: 1,
            filter: "blur(0px)"
          }}
          transition={{
            duration: 1,
            ease: "easeOut"
          }}
        >
          <div>
            <div className="music-title">Enjoy some electronic dj sets from myself, friends or some of my favorite djs</div>
            <br />
            <SoundcloudPlayer
              isActive={activePlayer === 'soundcloud'}
              onPlay={handleSoundcloudPlay}
              onPause={handleSoundcloudPause}
              isPlaying={isPlayingSoundcloud}
            />
          </div>
          <div>
            <div className="music-title">Enjoy a playlist of some of the music I have been listening to lately</div>
            <br />
            <YoutubePlayer
              isActive={activePlayer === 'youtube'}
              onPlay={handleYoutubePlay}
              onPause={handleYoutubePause}
              isPlaying={isPlayingYoutube}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Playground;
